module.exports = __webpack_public_path__ + "static/img/contentPic.41a59676.png";